export const findGroupTargetId = (el: Element | null): string | null => {
	let current: Element | null = el;
	while (current) {
		if (current.id) return current.id;
		current = current.parentElement;
	}
	return null;
};
